@if (showLabel && (question?.question_copy || question?.email_version)) {
  <label
    [innerHtml]="question?.question_copy || question?.email_version">
  </label>
}

@if (showCopy) {
  <div class="mb-20">
    <app-highlight-message
      variant="info"
      icon="copy"
      message="You can copy added benefits from another insured item to save you time">
      <a
        highlightMessageTray="primary"
        href="#copy-benefits-modal"
        data-toggle="modal"
        class="button button--sm">Select item</a>
    </app-highlight-message>
  </div>
}
@for (benefit of benefits; track benefit) {
  <div class="custom-traffic-edit" [ngClass]="{'is-added': benefit.add == 0}" id="demo-complex-edit">
    <div class="custom-traffic-edit__body">
      <div class="custom-traffic-edit__details">
        <div class="custom-traffic-edit__label">
          <div class="custom-traffic-edit__icon">
            <img src="assets/icn/vaps/sm-{{benefit.vaps_icon}}" alt="" [fallbackImage]="'assets/class/sm-0.svg'" class="icon icon--md">
          </div>
          <div class="custom-traffic-edit__title">
            <h6>{{benefit?.vaps_name}}</h6>
          </div>
        </div>
        <div class="custom-traffic-edit__content">
          <p class="readmore" data-widget="ReadMore" data-splitlength="15">
            {{benefit?.vaps_description}}
          </p>
        </div>
        <div class="custom-traffic-edit__more">
          <a href="#demo-wording-modal" (click)="showWording(benefit)"  data-toggle="dialog" class="button-control">
            <strong>See wording</strong>
          </a>
        </div>
      </div>
      <div class="custom-traffic-edit__other">
        @if (benefit?.premium) {
          <div class="custom-traffic-edit__price">
            <p class="price price--sm"><small></small> <strong>{{benefit?.premium}}</strong>/mo </p>
          </div>
        }
        <div class="custom-traffic-edit__actions">
          @if (benefit?.add == 1) {
            <a href="javascript:;" (click)="openQuestions(benefit, benefit?.vaps_id)" class="action-icon" id="demo-complex-add-btn-{{benefit?.vaps_id}}">
              <div class="action-icon__icon">
                <svg class="icon">
                  <use xlink:href="#add-items"></use>
                </svg>
              </div>
              <small class="action-icon__label">Add</small>
            </a>
          }
          @if (benefit?.add == 0 && benefit?.edit == 0) {
            <a href="javascipt:void(0)" (click)="removeBenefit(benefit)"  class="action-icon" id="demo-simple-remove-btn-{{benefit?.vaps_id}}">
              <div class="action-icon__icon">
                <svg class="icon">
                  <use xlink:href="#trash-bin"></use>
                </svg>
              </div>
              <small class="action-icon__label">Remove</small>
            </a>
          }
          @if (benefit?.cancel == 1 && benefit?.edit == 0) {
            <a href="javascript:;" (click)="cancelBenefit(benefit, benefit?.vaps_id)" class="action-icon" id="demo-complex-cancel-btn-{{benefit?.vaps_id}}">
              <div class="action-icon__icon">
                <svg class="icon">
                  <use xlink:href="#close-medium"></use>
                </svg>
              </div>
              <small class="action-icon__label">Cancel</small>
            </a>
          }
        </div>
      </div>
      @if (benefit?.edit == 1) {
        <div class="custom-traffic-edit__added" id="demo-complex-added-{{benefit?.vaps_id}}">
          <div class="cover-item-edit">
            <div class="cover-item-edit__label">
              <h6>{{getDescription(benefit?.description,0)}}</h6>
              <p>{{getDescription(benefit?.description,1)}}</p>
            </div>
            <div class="cover-item-edit__actions">
              <a href="javascrip:void(0)" (click)="removeBenefit(benefit)" class="action-icon action-icon--white">
                <div class="action-icon__icon">
                  <svg class="icon">
                    <use xlink:href="#trash-bin"></use>
                  </svg>
                </div>
                <small class="action-icon__label">Remove</small>
              </a>
              <a href="javascrip:void(0)" (click)="openQuestions(benefit, benefit?.vaps_id)" class="action-icon action-icon--white">
                <div class="action-icon__icon">
                  <svg class="icon">
                    <use xlink:href="#edit"></use>
                  </svg>
                </div>
                <small class="action-icon__label">Edit</small>
              </a>
            </div>
          </div>
        </div>
      }
    </div>
    @if (benefit?.itk[0]?.body_text) {
      <div class="custom-traffic-edit__carousel" id="demo-simple-carousel-{{benefit?.vaps_id}}">
        <div class="slider slider--compact slider--traffic">
          @for (itk of benefit?.itk; track itk) {
            <div class="slider__slide">
              <p class="font-semibold mb-5">Important to know</p>
              <p>
                {{ itk?.body_text }}
              </p>
            </div>
          }
        </div>
      </div>
    }
    <div class="custom-traffic-edit__additional d-none" id="demo-complex-add-container-{{benefit.vaps_id}}">
      <div class="custom-traffic-edit__additional-wrap">
        <div class="custom-traffic-edit__additional-inner" id="demo-additional-questions-q1">
          @if (currentQuestion) {
            <app-question-controller
              [question]="currentQuestion"
              [showLabel]="true"
              [showParent]="false"
              [isEditModal]="false"
              [readOnly]="false"
              [showLabelEmailVersion]="true"
              (questionAnswer)="questionAnswerResponse($event)"
              (questionHasError)="continueDisabled = $event"
              [controlCssClass]="' '">
            </app-question-controller>
          }
        </div>
        <!-- <div class="custom-traffic-edit__additional-inner" id="demo-additional-questions-q1">
        <div class="form-group">
          <label>Nulla tempor mauris quis porttitor placerat. Ut sed sollicitudin ipsum, malesuada egestas ipsum?</label>
          <label class="custom-input custom-input--radio custom-input--vehicle">
            <input type="radio" name="radio-example[]">
            <span class="custom-input__indi"></span>
            <span class="custom-input__label">
              <h5 class="font-16">Basic</h5>
              <p class="helper-text"> Quis porttitor placerat </p>
            </span>
          </label>
          <label class="custom-input custom-input--radio custom-input--vehicle">
            <input type="radio" name="radio-example[]">
            <span class="custom-input__indi"></span>
            <span class="custom-input__label">
              <h5 class="font-16">Regular</h5>
              <p class="helper-text">Quis porttitor placerat</p>
            </span>
          </label>
          <label class="custom-input custom-input--radio custom-input--vehicle">
            <input type="radio" name="radio-example[]">
            <span class="custom-input__indi"></span>
            <span class="custom-input__label">
              <h5 class="font-16">Luxury</h5>
              <p class="helper-text">Quis porttitor placerat</p>
            </span>
          </label>
        </div>
      </div>
      <div class="custom-traffic-edit__additional-inner" id="demo-additional-questions-q2">
        <p class="mb-20">How many days molestie augue at iaculis?</p>
        <div class="form-group">
          <label><strong>Label</strong></label>
          <input type="text" value="Andrew" placeholder="Name" class="form-control">
        </div>
      </div> -->
      <div class="custom-traffic-edit__additional-nav">
        @if (currentQuestion?.flow_index != 1) {
          <a href="javascript:;" (click)="previousQuestion()" class="button button--no-min button--naked" id="additional-questions-back-btn">Back</a>
        }
        <a href="javascript:;" (click)="!continueDisabled && nextQuestion()" [class.button--disabled]="continueDisabled" class="button button--primary" id="additional-questions-continue-btn">Continue</a>
      </div>
    </div>
  </div>
</div>
}
<!-- <app-addon-modal #addonModalComponent (benefitAdded)="benefitAdded($event)"></app-addon-modal> -->

@if (false) {
  <div class="modal fade modal--mini" id="demo-wording-modal_" tabindex="-1" role="dialog" aria-labelledby="demo-wording-modal" aria-modal="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content modal-mini">
        <div class="modal-mini__heading">
          <div class="container-fluid">
            <h4 [innerHTML]="selectedBenefit?.heading"></h4>
          </div>
        </div>
        <div class="modal-mini__content">
          <div class="container-fluid">
            <div class="rte">
              <p [innerHTML]="selectedBenefit?.body_text">
              </p>
              <!-- <h5>Lorem ipsum dolor sit amet.</h5> -->
              <!-- <table class="table table--minimal">
              <thead>
                <tr>
                  <th>Extension Name</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>[Label]</td>
                  <td>[Text]</td>
                </tr>
                <tr>
                  <td>[Label]</td>
                  <td>[Text]</td>
                </tr>
                <tr>
                  <td>[Label]</td>
                  <td>[Text]</td>
                </tr>
                <tr>
                  <td>[Label]</td>
                  <td>[Text]</td>
                </tr>
                <tr>
                  <td>[Label]</td>
                  <td>[Text]</td>
                </tr>
                <tr>
                  <td>[Label]</td>
                  <td>[Text]</td>
                </tr>
                <tr>
                  <td>[Label]</td>
                  <td>[Text]</td>
                </tr>
                <tr>
                  <td>[Label]</td>
                  <td>[Text]</td>
                </tr>
              </tbody>
            </table> -->
          </div>
        </div>
      </div>
      <div class="modal-mini__button">
        <div class="container-fluid">
          <a href="#" data-dismiss="modal" class="button button--primary">Got it</a>
        </div>
      </div>
    </div>
  </div>
</div>
}

@if (selectedBenefit?.wording) {
  <dialog class="dialog" id="demo-wording-modal">
    <div class="dialog-inner">
      <div class="dialog-content modal-alert modal-alert--alt">
        <div class="modal-alert__heading">
          <div class="container-fluid">
            <h4 [innerHTML]="selectedBenefit?.wording[0].heading"></h4>
          </div>
        </div>
        <div class="modal-mini__content">
          <div class="container-fluid">
            <div class="rte">
              <p [innerHTML]="selectedBenefit?.wording[0].body_text">
              </p>
              <!-- <h5>Lorem ipsum dolor sit amet.</h5> -->
              <!-- <table class="table table--minimal">
              <thead>
                <tr>
                  <th>Extension Name</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>[Label]</td>
                  <td>[Text]</td>
                </tr>
                <tr>
                  <td>[Label]</td>
                  <td>[Text]</td>
                </tr>
                <tr>
                  <td>[Label]</td>
                  <td>[Text]</td>
                </tr>
                <tr>
                  <td>[Label]</td>
                  <td>[Text]</td>
                </tr>
                <tr>
                  <td>[Label]</td>
                  <td>[Text]</td>
                </tr>
                <tr>
                  <td>[Label]</td>
                  <td>[Text]</td>
                </tr>
                <tr>
                  <td>[Label]</td>
                  <td>[Text]</td>
                </tr>
                <tr>
                  <td>[Label]</td>
                  <td>[Text]</td>
                </tr>
              </tbody>
            </table> -->
          </div>
        </div>
      </div>
      <div class="modal-alert__button">
        <div class="container">
          <a id="remove-cover-btn" href="javascript:;" data-toggle="modal" data-dismiss="dialog"
          class="button button--lg button--primary">Got it</a>
        </div>
      </div>
    </div>
  </div>
  <div class="ui-selectmenu-menu ui-front">
    <ul aria-hidden="true" aria-labelledby="ui-id-1-button" id="ui-id-1-menu" role="listbox" tabindex="0"
    class="ui-menu ui-corner-bottom ui-widget ui-widget-content"></ul>
  </div>
</dialog>
}